import { Component, Input, Output, EventEmitter, OnInit, OnChanges, SimpleChanges, ViewChildren, QueryList, ElementRef, HostListener } from '@angular/core';
import { DestructorComponent } from 'src/app/components/destructor/destructor.component';
import { CreditDebitNotesService } from 'src/app/services/credit-debit-notes/credit-debit-notes.service';
import { DepositService } from 'src/app/services/deposit/deposit.service';
import { InvoiceService } from 'src/app/services/invoice/invoice.service';
import { NonPaginatedResponse } from 'src/app/shared/models';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-invoice-listing',
  templateUrl: './invoice-listing.component.html',
  styleUrls: ['./invoice-listing.component.scss']
})
export class InvoiceListingComponent extends DestructorComponent implements OnInit, OnChanges {
  invoices: any[] = [];
  creditDebitNotes: any[] = [];
  @Input() customerId: string | null = null;
  @Input() customerCurrency: string | null = "jpy";
  @Input() showAllocateAmount: boolean = true;
  @Input() activeFilters: any = {};
  @Output() allocationChanged = new EventEmitter<any[]>();
  @Output() allocationDeleted = new EventEmitter<void>();
  @ViewChildren('tooltipPopup') tooltipPopups!: QueryList<ElementRef>;

  isLoading: boolean = false;
  isCreditDebitLoading: boolean = false;
  allocations: { [key: string]: { allocate_amount: string, allocation_finalized_date: string } } = {};
  creditDebitAllocations: { [key: string]: { allocate_amount: string, allocation_finalized_date: string } } = {};
  currentTooltip: HTMLElement | null = null;
  selectedInvoiceForModal: any = null;

  constructor(private _primaryService: InvoiceService, private _creditDebitNotesService: CreditDebitNotesService, private _depositService:DepositService) {
    super();
  }

  ngOnInit(): void {
    if (this.customerId) {
      this.GetData();
      this.GetCreditDebitData();
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['customerId'] && !changes['customerId'].firstChange) {
      this.GetData();
      this.GetCreditDebitData();
      console.log({customerCurrency:this.customerCurrency})
    }

    if (changes['activeFilters'] && !changes['activeFilters'].firstChange) {
      this.GetData();
      this.GetCreditDebitData();
      // TODO: Apply filters to invoice data or API call
      // This will be implemented later as requested
    }
  }

  onAllocationChange(invoiceId: string, field: string, event: any): void {
    const value = event.target.value;
    if (!this.allocations[invoiceId]) {
      this.allocations[invoiceId] = { allocate_amount: '', allocation_finalized_date: '' };
    }
    if (field === 'allocate_amount') {
      this.allocations[invoiceId].allocate_amount = value;
    } else if (field === 'allocation_finalized_date') {
      this.allocations[invoiceId].allocation_finalized_date = value;
    }
    this.emitAllocations();
  }

  onCreditDebitAllocationChange(creditDebitNoteId: string, field: string, event: any): void {
    const value = event.target.value;
    if (!this.creditDebitAllocations[creditDebitNoteId]) {
      this.creditDebitAllocations[creditDebitNoteId] = { allocate_amount: '', allocation_finalized_date: '' };
    }
    if (field === 'allocate_amount') {
      this.creditDebitAllocations[creditDebitNoteId].allocate_amount = value;
    } else if (field === 'allocation_finalized_date') {
      this.creditDebitAllocations[creditDebitNoteId].allocation_finalized_date = value;
    }
    this.emitAllocations();
  }

  private emitAllocations(): void {
    const invoiceAllocationData = Object.keys(this.allocations)
      .filter(invoiceId => this.allocations[invoiceId].allocate_amount || this.allocations[invoiceId].allocation_finalized_date)
      .map(invoiceId => ({
        _id: invoiceId,
        type: 'invoice',
        allocate_amount: this.allocations[invoiceId].allocate_amount,
        allocation_finalized_date: this.allocations[invoiceId].allocation_finalized_date
      }));

    const creditDebitAllocationData = Object.keys(this.creditDebitAllocations)
      .filter(creditDebitNoteId => this.creditDebitAllocations[creditDebitNoteId].allocate_amount || this.creditDebitAllocations[creditDebitNoteId].allocation_finalized_date)
      .map(creditDebitNoteId => ({
        _id: creditDebitNoteId,
        type: 'credit_debit_note',
        allocate_amount: this.creditDebitAllocations[creditDebitNoteId].allocate_amount,
        allocation_finalized_date: this.creditDebitAllocations[creditDebitNoteId].allocation_finalized_date
      }));

    const allocationData = [...invoiceAllocationData, ...creditDebitAllocationData];
    this.allocationChanged.emit(allocationData);
  }

  hasAllocations(): boolean {
    return Object.keys(this.allocations).some(invoiceId =>
      this.allocations[invoiceId].allocate_amount || this.allocations[invoiceId].allocation_finalized_date
    );
  }

  toggleTooltip(event: MouseEvent, _invoice: any): void {
    const target = event.currentTarget as HTMLElement;
    const tooltip = target.querySelector('.invoice-details-popup') as HTMLElement;

    if (!tooltip) return;

    // If this tooltip is already open, close it
    if (this.currentTooltip === tooltip) {
      this.hideTooltip();
      return;
    }

    // Hide any existing tooltip
    this.hideTooltip();

    // Show the tooltip
    tooltip.style.display = 'block';
    this.currentTooltip = tooltip;

    // Position the tooltip
    this.positionTooltip(target, tooltip);
  }

  hideTooltip(): void {
    if (this.currentTooltip) {
      this.currentTooltip.style.display = 'none';
      this.currentTooltip = null;
    }
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent): void {
    if (this.currentTooltip) {
      const target = event.target as HTMLElement;
      // Check if click is outside the popup and outside the trigger
      const isClickInsidePopup = this.currentTooltip.contains(target);
      const isClickInsideTrigger = target.closest('.invoice-hover-container') !== null;

      if (!isClickInsidePopup && !isClickInsideTrigger) {
        this.hideTooltip();
      }
    }
  }

  closeTooltip(): void {
    this.hideTooltip();
  }

  private positionTooltip(trigger: HTMLElement, tooltip: HTMLElement): void {
    const triggerRect = trigger.getBoundingClientRect();
    const tooltipRect = tooltip.getBoundingClientRect();
    const viewportWidth = window.innerWidth;
    const viewportHeight = window.innerHeight;
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    const scrollLeft = window.pageXOffset || document.documentElement.scrollLeft;

    let top = triggerRect.bottom + scrollTop + 8;
    let left = triggerRect.left + scrollLeft + (triggerRect.width / 2) - (tooltipRect.width / 2);

    // Adjust horizontal position if tooltip goes outside viewport
    if (left < scrollLeft + 10) {
      left = scrollLeft + 10;
    } else if (left + tooltipRect.width > scrollLeft + viewportWidth - 10) {
      left = scrollLeft + viewportWidth - tooltipRect.width - 10;
    }

    // Adjust vertical position if tooltip goes outside viewport
    if (top + tooltipRect.height > scrollTop + viewportHeight - 10) {
      // Show above the trigger
      top = triggerRect.top + scrollTop - tooltipRect.height - 8;
    }

    // Ensure tooltip doesn't go above the viewport
    if (top < scrollTop + 10) {
      top = scrollTop + 10;
    }

    tooltip.style.top = `${top}px`;
    tooltip.style.left = `${left}px`;
  }

  openInvoiceModal(invoice: any): void {
    this.selectedInvoiceForModal = invoice;

    // Open the modal using Bootstrap
    const modalElement = document.getElementById('kt_modal_plain_invoice');
    if (modalElement) {
      const modal = new (window as any).bootstrap.Modal(modalElement);
      modal.show();
    }
  }

  GetData() {
    this.isLoading = true;
    this.subscriptions.push(
      this._primaryService.GetData("1", "", { paginate: false, customer_id: this.customerId, status : "approved",...this.activeFilters }).subscribe({
        next: (response: NonPaginatedResponse<any>) => {
          console.log('API Response:', response); // Debug log
          if (response.status && response.data) {
            this.invoices = response.data || [];
          } else {
            this.invoices = [];
            console.log('No data found in response'); // Debug log
          }
          this.isLoading = false;
        },
        error: (error) => {
          console.error('Error loading invoices:', error);
          this.invoices = [];
          this.isLoading = false;
        }
      })
    );
  }

  GetCreditDebitData() {
    this.isCreditDebitLoading = true;
    this.subscriptions.push(
      this._creditDebitNotesService.GetData("1", "", { paginate: false, customer_id: this.customerId,...this.activeFilters }).subscribe({
        next: (response: NonPaginatedResponse<any>) => {
          console.log('Credit/Debit Notes API Response:', response); // Debug log
          if (response.status && response.data) {
            this.creditDebitNotes = response.data || [];
          } else {
            this.creditDebitNotes = [];
            console.log('No credit/debit notes found in response'); // Debug log
          }
          this.isCreditDebitLoading = false;
        },
        error: (error) => {
          console.error('Error loading credit/debit notes:', error);
          this.creditDebitNotes = [];
          this.isCreditDebitLoading = false;
        }
      })
    );
  }

  sumOfAllocations(allocations: any,currency_type:string = "usd"){

    let sum = 0;

    let amount_prop = currency_type == "usd"?"amount_in_usd":"amount_in_jpy";

    allocations.forEach((allocation: any) => {
      sum += allocation[amount_prop]?(+allocation[amount_prop]):0;
    });
    return sum;

  }

  averageOfRate(allocations: any){

    let sum = 0;
    let usd_sum = 0;
    let jpy_sum = 0;
    allocations.forEach((allocation: any) => {
      sum += allocation.ex_rate?(+allocation.ex_rate):0;
      usd_sum += allocation.amount_in_usd?(+allocation.amount_in_usd):0
      jpy_sum += allocation.amount_in_jpy?(+allocation.amount_in_jpy):0
    });

    return jpy_sum && usd_sum?(jpy_sum / usd_sum).toFixed(2):0;

  }

  // Method to clear all allocation inputs
  clearAllocations(): void {
    this.allocations = {};
    this.creditDebitAllocations = {};
    this.emitAllocations();

    // Clear the input fields in the DOM
    const allocationInputs = document.querySelectorAll('input[placeholder*="$100"], input[placeholder*="¥100"]') as NodeListOf<HTMLInputElement>;
    allocationInputs.forEach(input => {
      input.value = '';
    });
  }

  // Calculate total invoice amount
  getTotalInvoiceAmount(): number {
    return this.invoices.reduce((sum, invoice) => {
      return sum + (invoice.invoice_amount || 0);
    }, 0);
  }

  // Calculate total balance TT (currently always 0 based on the template)
  getTotalBalanceTT(): number {
    return 0; // Balance TT is hardcoded as 0 in the template
  }

  // Calculate total due
  getTotalDue(): number {
    return this.invoices.reduce((sum, invoice) => {
      return sum + (invoice.balance || 0);
    }, 0);
  }

  // Calculate total allocated
  getTotalAllocated(): number {
    return this.invoices.reduce((sum, invoice) => {
      return sum + (invoice.paid || 0);
    }, 0);
  }

  // Calculate total balance due
  getTotalBalanceDue(): number {
    return this.invoices.reduce((sum, invoice) => {
      return sum + (invoice.balance || 0);
    }, 0);
  }

  deleteAllocation(allocation: any, event: MouseEvent): void {
    event.stopPropagation();
    Swal.fire({
      title: 'Are you sure?',
      text: 'You are about to delete this allocation. This action cannot be undone.',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      cancelButtonColor: '#3085d6',
      confirmButtonText: 'Yes, delete it!'
    }).then((result) => {
      if (result.isConfirmed) {
        this.performDeleteAllocation(allocation);
      }
    });
  }

  private performDeleteAllocation(allocation: any): void {
    const allocationId = allocation._id || allocation.id;
    this.subscriptions.push(
      this._depositService.DeleteAllocation(allocationId).subscribe({
        next: (response: any) => {
          if (response.status) {
            Swal.fire({
              title: 'Deleted!',
              text: 'Allocation has been deleted successfully.',
              icon: 'success',
              confirmButtonText: 'OK'
            }).then(() => {
              this.hideTooltip();
              this.GetData();
              this.GetCreditDebitData();
              this.allocationDeleted.emit();
            });
          } else {
            Swal.fire({
              title: 'Error!',
              text: response.message || 'Failed to delete allocation.',
              icon: 'error',
              confirmButtonText: 'OK'
            });
          }
        },
        error: (error: any) => {
          Swal.fire({
            title: 'Error!',
            text: error.error?.message || 'An error occurred while deleting allocation.',
            icon: 'error',
            confirmButtonText: 'OK'
          });
        }
      })
    );
  }
}
